import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IResetLoginRateLimitingParams {
  systemUserIds?: string[];
}

export interface IResetLoginRateLimitingResult extends IResult {
}

export class ResetLoginRateLimitingRequest extends Request<IResetLoginRateLimitingParams, IResetLoginRateLimitingResult> {
  constructor(params: IResetLoginRateLimitingParams) {
    super('resetLoginRateLimiting', params);
  }
}
